import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { getNotifications, markAllNotifications } from '../../../services/notificationService';
import { apiParamsState, workspaceState } from '../../../storage/app';
import {
  notificationsCursorPageState,
  notificationsState,
  unreadNotificationsCountState,
} from '../../../storage/notifications';
import { NotificationTypeItem } from '../../../types/notification';
import { getPageRouteByNavKey } from '../../../utils/pages';

export function useNotification() {
  const apiParams = useRecoilValue(apiParamsState);
  const workspace = useRecoilValue(workspaceState);
  const setNotifications = useSetRecoilState(notificationsState);
  const setUnreadNotificationsCount = useSetRecoilState(unreadNotificationsCountState);
  const [notificationsCursorPage, setNotificationsCursorPage] = useRecoilState(notificationsCursorPageState);

  const loadNotificationsList = async (notificationType?: NotificationTypeItem, nextPage = false) => {
    if (!apiParams) return;
    const { notifications, error, totalUnread, cursor } = await getNotifications(
      apiParams.clientId,
      apiParams.subClientId,
      notificationType,
      nextPage && notificationsCursorPage?.hasNext ? notificationsCursorPage.after : undefined,
    );

    if (error) {
      setNotifications(undefined);
      setNotificationsCursorPage(undefined);
      setUnreadNotificationsCount(undefined);
      return { error };
    } else {
      if (notifications)
        setNotifications((prev) => {
          if (nextPage) return [...prev!, ...notifications];
          return [...notifications];
        });
      setUnreadNotificationsCount(totalUnread);
      setNotificationsCursorPage(cursor);
    }
  };

  const markNotifications = async (action: string) => {
    if (!apiParams) return;
    const { error } = await markAllNotifications(apiParams.clientId, apiParams.subClientId, action);

    if (error) {
      return { error };
    }
  };

  const getRoute = (tab: string) => {
    if (!workspace) return;
    if (tab) {
      const route = getPageRouteByNavKey(workspace._id, 'account');
      if (route) return route.replace(':tab', tab);
    }
  };

  return {
    loadNotificationsList,
    markNotifications,
    getRoute,
  };
}
